import { render, staticRenderFns } from "./NewUiFooter.vue?vue&type=template&id=4e22b309&scoped=true"
import script from "./NewUiFooter.vue?vue&type=script&lang=js"
export * from "./NewUiFooter.vue?vue&type=script&lang=js"
import style0 from "./NewUiFooter.vue?vue&type=style&index=0&id=4e22b309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e22b309",
  null
  
)

export default component.exports